<template>
  <div style="overflow: hidden">
    <div :class="['bg_wra', $route.params.name]">
      <h1>{{ title }}</h1>
      <h4 v-html="subtitle" class="padd-rig"></h4>
    </div>
    <div class="submenu">
      <a-anchor :offset-top="72" @click="handleClick" @change="onChange">
        <!-- <a-anchor-link href="#1001" title="业务挑战"></a-anchor-link> -->
        <a-anchor-link href="#1002" title="解决方案" :class="{ 'ant-anchor-link-active': isActive }"></a-anchor-link>
        <!-- <a-anchor-link href="#1003" title="应用蓝图"></a-anchor-link> -->
        <a-anchor-link href="#1004" title="成功故事"></a-anchor-link>
      </a-anchor>
    </div>
    <!-- <div class="challenge" id="1001">
      <h1>业务挑战</h1>
      <a-row :gutter="16">
        <a-col :span="12" v-for="(item, index) in challenge" :key="index">
          <div class="half_part">
            <img :src="item.icon" alt="" />
            <div class="part_text">
              <h3>{{ item.text }}</h3>
              <h4>{{ item.subtext }}</h4>
            </div>
          </div>
        </a-col>
      </a-row>
    </div> -->
    <div class="program" id="1002">
      <div :class="['program_con', $route.params.name]">
        <div class="program_wra">
          <h1>{{ title }}</h1>
          <a-row :gutter="8">
            <a-col :span="12" v-for="(item, index) in programs" :key="index">
              <div class="half-col">
                <div class="title">{{ item.title }}</div>
                <p>{{ item.desc }}</p>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <!-- <div class="blueprint" id="1003">
      <h1>应用蓝图</h1>
      <h4>{{ info }}</h4>
      <img src="https://ow-resource.gousii.com/image/solution/lantu.png" alt="" />
    </div> -->
    <div class="partner" id="1004">
      <div class="stories">
        <div class="stories_wra">
          <h1>客户成功故事</h1>
          <a-row :gutter="8">
            <a-col :span="12" v-for="(item, index) in stories[$route.params.name]" :key="index">
              <div class="stories-col" @click="linkTo(item.link)">
                <img :src="item.src" alt="" />
                <p>{{ item.desc }}</p>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import solutionData from "./solutionData";
export default {
  name: "SolutionDetails",
  data() {
    return {
      title: "",
      subtitle: "",
      challenge: "",
      programs: "",
      stories: {
        gongyu: [
          {
            src: "https://ow-resource.gousii.com/image%2F%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E6%B9%BE%E6%B5%81.png",
            desc: "湾流国际：白领公寓先行者，成功运营118个高端社区，管理超35000套房源",
            link: "",
          },
          {
            src: "https://ow-resource.gousii.com/image/%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E4%B8%B0%E4%B9%90%E5%AE%B6.png",
            desc: "丰乐家：顺丰全资控股的直营公寓品牌，已成功运营15家门店，服务超4000名顺丰员工",
            link: "",
          },
        ],
        yuanqu: [
          {
            src: "https://ow-resource.gousii.com/image%2F%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E7%BB%BF%E8%B0%B7%E5%9B%AD%E5%8C%BA.png",
            desc: "绿谷园区：科技连接你我，智慧社区共筑未来",
            link: "",
          },
          {
            src: "https://ow-resource.gousii.com/image%2F%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E5%8D%83%E5%9F%8E%E9%9B%86%E5%9B%A2.png",
            desc: "千城集团：致力成为中国领先的城市更新运营服务商",
            link: "",
          },

        ],
        shangye: [
          {
            src: "https://ow-resource.gousii.com/image/%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E6%97%BA%E9%93%BA%E9%80%9A.png",
            desc: "旺铺通：为1000万中小商户提供专业的社区商业运营服务",
            link: '',
          },
          {
            src: "https://ow-resource.gousii.com/image/%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E4%B8%87%E8%A1%97.png",
            desc: "万街商业：35城布局、160万平管理、超400亿资产，是国内领先的社区商业集成服务商",
          },
        ],
        lingshou: [
          {
            src: "https://ow-resource.gousii.com/image/%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E6%97%BA%E9%93%BA%E9%80%9A%E9%9B%B6%E5%94%AE.png",
            desc: "旺铺通零售：汇聚全球、服务万家、美好生活从这里启航",
            link: "",
          },
          {
            src: "https://ow-resource.gousii.com/image/%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-HiveBEST.png",
            desc: "HiveBEST：整合全球大家居产品供应链、提供一站式闭环式服务",
            link: "",
          },
        ],
      },
      info: "",
      isActive: true,
    };
  },
  watch: {
    // 利用watch方法检测路由变化：
    $route: function (to, from) {
      if (to.fullPath !== from.fullPath) {
        this.initData()
      }
    },
  },

  methods: {
    initData() {
      this.title = solutionData[this.$route.params.name].title;
      this.subtitle = solutionData[this.$route.params.name].subtitle;
      this.challenge = solutionData[this.$route.params.name].challenge;
      this.programs = solutionData[this.$route.params.name].programs;
      this.info = solutionData[this.$route.params.name].info;
    },
    handleClick(e, link) {
      e.preventDefault();
      console.log(link);
    },
    onChange(link) {
      console.log(link);
      if (link && link != "#1001") {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
    },
    linkTo(url) {
      url && window.open(url);
    },
  },
  created() {
    this.title = solutionData[this.$route.params.name].title;
    this.subtitle = solutionData[this.$route.params.name].subtitle;
    this.challenge = solutionData[this.$route.params.name].challenge;
    this.programs = solutionData[this.$route.params.name].programs;
    this.info = solutionData[this.$route.params.name].info;
  },
};
</script>

<style lang="less" scoped>
h1,
h3,
h4 {
  color: #41505f;
}

.bg_wra {
  height: 480px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  h1,
  h4 {
    color: white;
  }

  &.gongyu {


    background-image: url("https://ow-resource.gousii.com/image%2F%E6%99%BA%E6%85%A7%E5%85%AC%E5%AF%93.png");
  }

  &.yuanqu {
    background-image: url("https://ow-resource.gousii.com/image%2F%E6%99%BA%E6%85%A7%E5%9B%AD%E5%8C%BA.png");
  }

  &.shangye {
    background-image: url("https://ow-resource.gousii.com/image%2F%E6%99%BA%E6%85%A7%E5%95%86%E4%B8%9A.png");
  }

  &.yinhang {
    background-image: url("https://ow-resource.gousii.com/image/solution/lanling_bg.png");
  }

  &.lingshou {
    background-image: url("https://ow-resource.gousii.com/image%2F%E6%99%BA%E6%85%A7%E9%9B%B6%E5%94%AE.png");

    h1,
    h4 {
      color: #ffffff;
    }
  }

  h1 {
    width: 1200px;
    margin: 0 auto;
    padding-top: 170px;
  }

  h4 {
    width: 1200px;
    margin: 0 auto;
    font-size: 16px;
    padding-top: 20px;
  }

  .padd-rig {
    padding-right: 450px;
  }
}

.submenu {
  /deep/.ant-anchor {
    width: 1200px;
    margin: 0 auto;
  }

  /deep/.ant-anchor-ink {
    display: none;
  }

  /deep/.ant-anchor-link {
    display: inline-block;
    color: #41505f;
    font-size: 15px;
    padding: 0;
    margin-right: 60px;
    line-height: 60px;
  }

  /deep/.ant-anchor-link-title {
    color: #41505f;
    border-bottom: solid 3px transparent;
  }

  /deep/.ant-anchor-link-active>.ant-anchor-link-title {
    border-bottom: solid 3px #0085f1;
    color: #41505f;
  }
}

.challenge {
  width: 1200px;
  margin: 0 auto;
  padding-top: 72px;

  h1 {
    text-align: center;
    color: #41505f;
    font-size: 30px;
    margin-bottom: 50px;
  }

  .half_part {
    padding: 60px 30px 0;
    height: 200px;
    background: #f7f7f7;
    margin-bottom: 16px;
    overflow: hidden;

    img {
      width: 60px;
      height: 60px;
      float: left;
    }

    .part_text {
      float: left;
      margin-left: 20px;

      h3 {
        font-size: 22px;
      }

      h4 {
        width: 383px;
      }
    }
  }
}

.program {
  // padding-top: 72px;

  .program_con {
    height: 860px;
    padding: 68px 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    &.gongyu {
      background-image: url("https://ow-resource.gousii.com/image/solution/rencai_bg2.png");
    }

    &.yuanqu {
      background-image: url("https://ow-resource.gousii.com/image/solution/shangye_bg2.png");
    }

    &.shangye {
      background-image: url("https://ow-resource.gousii.com/image/solution/gongzu_bg2.png");
    }

    &.yinhang {
      background-image: url("https://ow-resource.gousii.com/image/solution/lanling_bg2.png");
    }

    &.lingshou {
      background-image: url("https://ow-resource.gousii.com/image/solution/lanling_bg2.png");
    }

    .program_wra {
      width: 1200px;
      margin: 0 auto;

      h1 {
        text-align: center;
        color: #fff;
        margin-bottom: 60px;
      }

      .half-col {
        height: 259px;
        padding: 60px 36px 0;
        background-color: rgba(36, 132, 237, 0.2);
        color: #fff;
        margin-bottom: 8px;

        &:hover {
          background-color: #2484ed;
        }

        .title {
          height: 80px;
          font-size: 22px;
          position: relative;

          &:before {
            content: "";
            display: block;
            width: 30px;
            height: 4px;
            background-color: #08bdfa;
            position: absolute;
            top: 50px;
            left: 0;
          }
        }
      }
    }
  }
}

.blueprint {
  width: 1200px;
  margin: 0 auto;
  padding-top: 72px;

  h1 {
    text-align: center;
  }

  h4 {
    text-align: center;
    padding: 0 50px;
  }

  img {
    margin-top: 50px;
    width: 100%;
  }
}

.partner {
  padding-top: 72px;

  .stories {
    background-color: #eaeff3;
    padding: 72px 0;

    .stories_wra {
      width: 1200px;
      margin: 0 auto;
      text-align: center;

      .stories-col {
        cursor: pointer;

        &:hover {
          box-shadow: 0px 5px 10px 0px rgba(18, 32, 46, 0.4);
        }
      }

      h1 {
        margin-bottom: 40px;
      }

      img {
        width: 100%;
        height: 256px;
      }

      p {
        font-size: 20px;
        background-color: #fff;
        margin-bottom: 10px;
        height: 100px;
        padding: 0 20px;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          box-shadow: 0px 7px 12px 4px rgba(225, 225, 225, 0.8);
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .bg_wra {
    height: 200px;
    padding: 0 10px;

    h1 {
      padding-top: 80px;
      width: 100%;
      font-size: 18px;
    }

    h4 {
      width: 100%;
      font-size: 12px;
      padding-top: 10px;
    }

    .padd-rig {
      padding-right: 70px;
    }
  }

  .submenu {
    display: none;
  }

  .challenge {
    width: 100%;
    padding-top: 30px;

    h1 {
      margin-bottom: 30px;
    }

    .half_part {
      height: 240px;
      padding: 20px 10px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;

      .part_text {
        width: 100%;
        margin-left: 0;
        text-align: center;

        h3 {
          width: 100%;
          font-size: 18px;
        }

        h4 {
          width: 100%;
          font-size: 12px;
        }
      }
    }
  }

  .program {
    padding-top: 32px;

    .program_con {
      height: auto;

      .program_wra {
        width: 100%;

        h1 {
          margin-bottom: 30px;
          font-size: 26px;
        }

        .half-col {
          padding: 20px 10px 0;
          font-size: 12px;
          height: 300px;

          .title {
            font-size: 18px;
          }
        }
      }
    }
  }

  .blueprint {
    width: 100%;
    padding-top: 32px;

    h4 {
      padding: 0 20px;
      font-size: 12px;
    }
  }

  .partner {
    padding-top: 32px;

    .stories {
      height: auto;
      padding: 32px 0;

      .stories_wra {
        width: 100%;

        img {
          height: 88px;
        }

        p {
          font-size: 12px;
          height: 100px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: inherit;
        }
      }
    }
  }
}
</style>
